"use client"

import { CategoriesList } from '../../../components/shared/categories/CategoriesList'
import HorizontalTab, { TabItem } from '../../../components/ui/HorizontalTab'
import { Category, Sector } from '@cabukaka/types'
import { Package } from 'lucide-react'
import  { useState, useMemo } from 'react'

interface PageProps {
    sectors: Sector[],
    categories: Category[];
}

export default function CategoriesBySector({ sectors, categories }: PageProps) {
    const [selectedSector, setSelectedSector] = useState<Sector | null>(null)

    const onSectorChange = (value: string) => {
        if (value === "all") {
            setSelectedSector(null)
            return
        }
        const sector = sectors.find(s => s.slug === value)
        if (sector) setSelectedSector(sector)
    }

    // Filtrer les catégories par secteur sélectionné
    const filteredCategories = useMemo(() => {
        if (!selectedSector) return categories
        return categories.filter(category => category.sectorId === selectedSector.id)
    }, [categories, selectedSector])

    // Ajouter l'onglet "Tous" au début
    const tabItems: TabItem[] = [
        { label: "Tous", value: "all" },
        ...sectors.map((sector) => ({
            label: sector.name,
            value: sector.slug || ""
        }))
    ]

    return (
        <div>
            <HorizontalTab
                tabItems={tabItems}
                onChange={onSectorChange}
                defaultValue="all"
                className=''
                showScrollButtons={true}
            />
            
            {/* Catégories filtrées par secteur */}
            <div id="all-categories" className="container mx-auto px-4 py-16 md:py-20">
                <div className="text-center mb-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                        {selectedSector ? `Catégories ${selectedSector.name}` : 'Toutes nos catégories'}
                    </h2>
                    <p className="text-gray-500 max-w-2xl mx-auto">
                        Parcourez notre sélection complète et trouvez l'inspiration
                    </p>
                </div>

                {filteredCategories.length === 0 ? (
                    <div className="text-center py-20">
                        <div className="inline-flex items-center justify-center w-24 h-24 bg-gray-100 rounded-full mb-6">
                            <Package className="w-12 h-12 text-gray-400" />
                        </div>
                        <h3 className="text-2xl font-semibold text-gray-700 mb-2">
                            Aucune catégorie
                        </h3>
                        <p className="text-gray-500">
                            Aucune catégorie n'est disponible pour {selectedSector?.name || 'le moment'}.
                        </p>
                    </div>
                ) : (
                    <CategoriesList
                        layout="grid"
                        categories={filteredCategories}
                    />
                )}
            </div>
        </div>
    )
}